import { Link } from "react-router-dom";
import React, { useEffect, useState, useMemo } from 'react';
import UserService from '../services/UserService';
import Paper from '@mui/material/Paper';
import { useStorefrontAdministrationConfig } from '../hooks/StorefrontAdministrationConfigContext';
import TranslatableDataGrid from './shared/TranslatableDataGrid';
import Loading from './Loading';
import { ThemeProvider } from '@mui/material/styles';
import StorefrontAdminTheme from './shared/MUIStyles/StorefrontAdminTheme';
import Typography from '@mui/material/Typography';
import { GridToolbarContainer, GridToolbarFilterButton, GridToolbarExport, GridToolbarDensitySelector } from '@mui/x-data-grid-premium';
import Box from '@mui/material/Box';
import { withProductConfig } from '../hooks/ProductConfigContext';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import Notifications from '../services/Notifications';
import * as cartActions from '../actions/cartActions';
import { useDispatch } from "react-redux";
import * as Roles from '../resources/UserRole'; 
import * as CartStatusNotifications from "../resources/CartStatusNotification";
import CartService from '../services/CartService';
import Authorize from './Authorize';
import MUIAlertModal from './shared/MUIAlertModal'; 

const UserFavorite = (props) => {

    const localized = props.productConfig.labels;
    const storefrontAdministrationConfig = useStorefrontAdministrationConfig();
    const localizedHeader = storefrontAdministrationConfig.labels;
    const dispatch = useDispatch();

    const theme = StorefrontAdminTheme;
    const [rows, setRows] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openDeleteAll, setOpenDeleteAll] = useState(false);
    
    const clickRemoveFavorite = async (e, row) => {
        e.stopPropagation();
        setSelectedRow(row);
        setOpenDelete(true);
    };
    const handleRemoveFavItem = async (productId, type) => {
        let processed = false;
        if (type == 'row') {
            const removedFavResponse = await UserService.removeUserFavorite(productId);
            if (removedFavResponse) {
                processed = true;
                Notifications.message(localized.DeleteFavorite);
            } else {
                Notifications.message(localized.FavoriteError);
            }
        }
        if (type == 'all') {
            const removedFavResponse = await UserService.removeUserFavoriteList();
            if (removedFavResponse) {
                setRows([]);
                Notifications.message(localized.DeleteFavorite);
            }
        }
        if (processed) {
            const totalRows = rows;
            var newRows = [];
            totalRows.filter(obj => obj.id !== productId).forEach((fav) => {
                newRows.push({
                    id: fav.id,
                    sku: fav.sku,
                    description: fav.description,
                    itemNumberShort: fav.itemNumberShort
                });
            });
            setRows(newRows);
        }
    }

    const getUserFavorite = () => {
        setFetching(true);
        var rows = [];
        UserService.getUserFavoriteList().then((data) => {
            if (data) {
                data.forEach((fav) => {
                    rows.push({
                        id: fav.productId,
                        sku: fav.sku,
                        description: fav.description,
                        itemNumberShort: fav.itemNumberShort
                    });
                });
                setRows(rows);
            }
            else {
                setRows([]);
            }
            setFetching(false);
        });
    }

    const columns = [
        {
            field: 'sku',
            headerName: localized.FavoriteItem,
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <Link to={`/product/${params.row.itemNumberShort}`}>
                        {params.row.sku}
                    </Link>
                )
            },
            flex: 0.4,
            maxWidth: 200
        },
        {
            field: 'description',
            headerName: localized.Description_Label,
            headerAlign: 'center',
            flex: 1.5,
            maxWidth: 400
        },
        {
            field: 'deleteButton',
            headerAlign: 'center',
            headerName: localized.DeleteFavoriteItem,
            renderCell: (params) => (
                <Button variant="standard" color="update" onClick={(e) => clickRemoveFavorite(e, params.row)} >
                    <DeleteIcon sx={{ fontSize: 20 }} />
                </Button>
            ),
            resizable: false,
            sortable: false,
        },
        {
            field: ' ',
            headerAlign: 'center',
            renderCell: (params) => (
                <Authorize hasRoles={[Roles.PLACE_ORDERS]} displayMessage={false}>
                    <Button variant="standard" color="update" onClick={(e) => addToCart(e, params.row)} >
                        {localized.ButtonText_AddToOrder}
                    </Button>
                </Authorize>
            ),
            sortable: false,
            flex: 1.5,
            maxWidth: 200
        },
    ];
    useEffect(() => {
        const loadFavorites = async () => {
            await getUserFavorite();
        };
        loadFavorites();
    }, []);


    const handleClickDeleteAll = async () => {
        setOpenDeleteAll(true);
    };

    const handleCloseDeleteAll = () => {
        setOpenDeleteAll(false);
    };

    const renderDeleteAllButton = () => (
        <MUIAlertModal
            open={openDeleteAll}
            onClose={handleCloseDeleteAll}
            title={localized.FavoriteAllDeleteConfirmation}
            confirmLabel={localized.ReturnConfirmationYes}
            cancelLabel={localized.ReturnConfirmationNo}
            onConfirm={(e) => {
                e.preventDefault();
                handleRemoveFavItem(null, 'all');
                handleCloseDeleteAll();
            }}
            confirmButtonProps={{ color: 'update' }}
            cancelButtonProps={{ color: 'error' }}
        />
    );

    const customToolbar = () => {      
        return (           
            <GridToolbarContainer>

                <Box sx={{ flexGrow: 1 }} />
                <GridToolbarFilterButton
                    slotProps={{
                        tooltip: { title: 'Filter list' }
                    }}
                    variant="outlined"
                    color="update"
                />
                <GridToolbarDensitySelector
                    slotProps={{
                        tooltip: { title: 'Change density' }
                    }}
                    variant="outlined"
                    color="update"
                />

                <GridToolbarExport
                    printOptions={{ disableToolbarButton: true }}
                    slotProps={{
                        tooltip: { title: 'Export data' }
                    }}
                    variant="outlined"
                    color="update"
                />
                <strong>
                    <Button
                        variant="standard"
                        color="success"
                        style={{ marginLeft: 16 }}
                        onClick={handleClickDeleteAll}
                    >
                        {localized.FavoriteAllDelete}
                    </Button>
                </strong>
            </GridToolbarContainer>
        );
    }
    const handleCloseDelete = () => {
        setOpenDelete(false);
    };
    const renderDeleteButton = (row) => (
        <MUIAlertModal
            open={openDelete}
            onClose={handleCloseDelete}
            title={localized.FavoriteDeleteConfirmation}
            confirmLabel={localized.ReturnConfirmationYes}
            cancelLabel={localized.ReturnConfirmationNo}
            onConfirm={(e) => {
                e.preventDefault();
                handleRemoveFavItem(row.id, 'row');
                handleCloseDelete();
            }}
            confirmButtonProps={{ color: 'update' }}
            cancelButtonProps={{ color: 'error' }}
        />
    );

    const addToCart = async (e, productDetail) => {
        try {           
            const item = { product: productDetail, quantity: 1 };
            const response = await CartService.add(item);
            const responseData = await response.json();
            const updatedItem = { ...item, id: responseData.id };           
            dispatch(cartActions.ItemAddedToCart(updatedItem));
            CartService.addToCartCallback(CartStatusNotifications.OrderUpdated, localized);
        }
        catch {
            CartService.addToCartCallback(CartStatusNotifications.UnableToAddToCart, localized);
        }
    }

    const favoriteItems = useMemo(() => {
        return (
            <Paper sx={{ height: 700, width: '100%' }}>
                <TranslatableDataGrid rows={rows} columns={columns} insetToolbar={customToolbar} labels={localizedHeader} />
            </Paper>
        );
    }, [rows, localized, localizedHeader]);
    return (
        <>
            {
                fetching && <Loading type="brand" />
            }
            {
                !fetching && (localized && Object.keys(localized).length > 0) &&
                <>
                    <ThemeProvider theme={theme}>
                        <Typography variant="h1">{localized.MyFavorites}</Typography>
                        {favoriteItems}
                        {openDelete && renderDeleteButton(selectedRow)}
                        {openDeleteAll && renderDeleteAllButton()}
                    </ThemeProvider>
                </>
            }
        </>
    );
};
export default withProductConfig(UserFavorite);
